var PeopleMedia = PeopleMedia || {};
PeopleMedia.CP = PeopleMedia.CP || {};
PeopleMedia.CP.Profile = (function ($jq) {
    "use strict";

    var Oid = "PeopleMedia.CP.Profile";

    var _siteId = PeopleMedia.CP.SiteID();
    var _includedQuestions = [];
    var _excludedQuestions = [];
    var _questionDefaultValues = [];
    var _questions = [];
    var _initialQuestions = [];
    var _standardQuestions = [];
    var _profileSiteQuestions = [];
    var _questionTextOverride = {};
    var _responseTextOverride = {};
    var _responseExclusions = {};
    var _profilePanelId = "divProfile";
    var _questionContainerId = "divProfileQuestions";
    var _questionTemplateId = "divProfileQuestionTemplate";
    var _responseFieldnamePrefix = "ddlProfileResponse_";
    var _busyClassname = "busy";
    var _onQuestionsLoaded = null;
    var _onQuestionDisplay = null;
    var _onQuestionsPreSubmit = null;
    var _onQuestionsSubmitted = null;
    var _currentPanelNumber = 1;
    var _panelCount = 1;
    var OPTION_LIST_TYPE_DROPDOWN = 0;
    var OPTION_LIST_TYPE_LIST = 1;
    var OPTION_LIST_TYPE_DIV = 2;
    var _defaultOptionListType = OPTION_LIST_TYPE_DROPDOWN;
    var _maxListViewSize = 10;
    var _addChooseOptionToResponses = true;
    var _nextPage = null;

    var SiteId = function(siteId) {
        if (arguments.length > 0) {
            _siteId = siteId;
        } else {
            return _siteId;
        }
    };

    var IncludedQuestions = function(includedQuestions) {
        if (arguments.length > 0) {
            _includedQuestions = includedQuestions;
        } else {
            return _includedQuestions;
        }
    };

    var ExcludedQuestions = function(excludedQuestions) {
        if (arguments.length > 0) {
            _excludedQuestions = excludedQuestions;
        } else {
            return _excludedQuestions;
        }
    };

    var QuestionDefaultValues = function(questionDefaultValues) {
        if (arguments.length > 0) {
            _questionDefaultValues = questionDefaultValues;
        } else {
            return _questionDefaultValues;
        }
    };

    var Questions = function() {
        return _questions;
    };

    var StandardQuestions = function() {
        return _standardQuestions;
    };

    var InitialQuestions = function(initialQuestions) {
        if (arguments.length > 0) {
            _initialQuestions = initialQuestions;
        } else {
            return _initialQuestions;
        }
    };

    var ProfilePanelId = function(profilePanelId) {
        if (arguments.length > 0) {
            _profilePanelId = profilePanelId;
        } else {
            return _profilePanelId;
        }
    };

    var ProfilePanel = function() {
        return $jq("#" + _profilePanelId);
    };

    var QuestionContainerId = function(questionContainerId) {
        if (arguments.length > 0) {
            _questionContainerId = questionContainerId;
        } else {
            return _questionContainerId;
        }
    };

    var QuestionTemplateId = function(questionTemplateId) {
        if (arguments.length > 0) {
            _questionTemplateId = questionTemplateId;
        } else {
            return _questionTemplateId;
        }
    };

    var ResponseFieldnamePrefix = function(responseFieldnamePrefix) {
        if (arguments.length > 0) {
            _responseFieldnamePrefix = responseFieldnamePrefix;
        } else {
            return _responseFieldnamePrefix;
        }
    };

    var BusyClassname = function(busyClassname) {
        if (arguments.length > 0) {
            _busyClassname = busyClassname;
        } else {
            return _busyClassname;
        }
    };

    var OnQuestionsLoaded = function(onQuestionsLoaded) {
        if (arguments.length > 0) {
            _onQuestionsLoaded = onQuestionsLoaded;
        } else {
            return _onQuestionsLoaded;
        }
    };

    var OnQuestionDisplay = function(onQuestionDisplay) {
        if (arguments.length > 0) {
            _onQuestionDisplay = onQuestionDisplay;
        } else {
            return _onQuestionDisplay;
        }
    };

    var OnQuestionsPreSubmit = function(onQuestionsPreSubmit) {
        if (arguments.length > 0) {
            _onQuestionsPreSubmit = onQuestionsPreSubmit;
        } else {
            return _onQuestionsPreSubmit;
        }
    };

    var OnQuestionsSubmitted = function(onQuestionsSubmitted) {
        if (arguments.length > 0) {
            _onQuestionsSubmitted = onQuestionsSubmitted;
        } else {
            return _onQuestionsSubmitted;
        }
    };

    var CurrentPanelNumber = function() {
        return _currentPanelNumber;
    };

    var PanelCount = function(panelCount) {
        if (arguments.length > 0) {
            _panelCount = panelCount;
        } else {
            return _panelCount;
        }
    };

    var DefaultOptionListType = function(defaultOptionListType) {
        if (arguments.length > 0) {
            _defaultOptionListType = defaultOptionListType;
        } else {
            return _defaultOptionListType;
        }
    };

    var AddChooseOptionToResponses = function(addChooseOptionToResponses) {
        if (arguments.length > 0) {
            _addChooseOptionToResponses = addChooseOptionToResponses;
        } else {
            return _addChooseOptionToResponses;
        }
    };

    var NextPage = function(nextPage) {
        if (arguments.length > 0) {
            _nextPage = nextPage;
        } else {
            return _nextPage;
        }
    };

    var addQuestionTextOverride = function(questionID, questionText) {
        _questionTextOverride[questionID] = questionText;
    };

    var addResponseTextOverride = function(questionID, responseID, responseText) {
        if (typeof(_responseTextOverride[questionID]) === 'undefined' || _responseTextOverride[questionID] === null) {
            _responseTextOverride[questionID] = {};
        }
        _responseTextOverride[questionID][responseID] = responseText;
    };

    var excludeResponse = function(questionID, responseID) {
        if (typeof(_responseExclusions[questionID]) === 'undefined' || _responseExclusions[questionID] === null) {
            _responseExclusions[questionID] = {};
        }
        _responseExclusions[questionID][responseID] = true;
    };

    var loadQuestions = function(options) {
        try {
            if (typeof options !== "object" || options === null) {
                options = {};
            }
            SiteId(PeopleMedia.CP.SiteID());

            // determine panel count
            for (var i = 1; i <= 30; ++i) {
                if ($jq('#divProfileQuestions_' + i.toString()).length > 0) {
                    PanelCount(i);
                } else {
                    break;
                }
            }

            reset();
            var thisObj = this;
            retrieveStandardQuestions(
                function(standardQuestions) {
                    var loadQuestionOptions = options;
                    _questions = [];
                    for (var initialIndex = 0; initialIndex < _initialQuestions.length; ++initialIndex) {
                        _questions[initialIndex] = _initialQuestions[initialIndex];
                    }
                    for (var standardIndex = 0; standardIndex < standardQuestions.length; ++standardIndex) {
                        if ($jq.inArray(standardQuestions[standardIndex].QuestionID, _excludedQuestions) < 0) {
                            _questions.push(standardQuestions[standardIndex]);
                        }
                    }
                    for (var questionIndex = 0; questionIndex < _questions.length; ++questionIndex) {
                        _questions[questionIndex].QuestionNumber = questionIndex + 1;

                        _questions[questionIndex].DefaultValue = null;
                        for (var defaultIndex = 0;
                            defaultIndex < _questionDefaultValues.length;
                            ++defaultIndex) {
                            if (_questionDefaultValues[defaultIndex].QuestionID ===
                                _questions[questionIndex].QuestionID) {
                                _questions[questionIndex].DefaultValue =
                                    _questionDefaultValues[defaultIndex].DefaultValue;
                            }
                        }

                        addQuestionHTMLToPanel(_questions[questionIndex], questionIndex);
                        updateQuestionPlaceholder(_questions[questionIndex]);
                    }
                    // PeopleMedia.CP.trackRegistrationEventLoadProfileQuestions(_questions);
                    if (loadQuestionOptions.loadOnly !== true) {
                        showPanel(1, "retrieveStandardQuestions onSuccess");
                    }
                    var onQuestionsLoaded = OnQuestionsLoaded();
                    if (typeof(onQuestionsLoaded) !== 'undefined' && onQuestionsLoaded !== null) {
                        onQuestionsLoaded(thisObj, _questions, loadQuestionOptions);
                    }
                },
                function(errors) {
                    var loadQuestionOptions = options;
                    if (options.optionalQuestions) {
                        _questions = [];
                        var onQuestionsLoaded = OnQuestionsLoaded();
                        if (typeof(onQuestionsLoaded) !== 'undefined' && onQuestionsLoaded !== null) {
                            onQuestionsLoaded(thisObj, _questions, loadQuestionOptions);
                        }
                    } else {
                        var firstError = PeopleMedia.CP.getFirstError(errors);
                        if (firstError && firstError.IsAjaxError) {
                            questionsCompleted();
                        } else {
                            PeopleMedia.CP.Messaging.show(errors);
                        }
                    }
                });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadQuestions" });
        }
    };

    var retrieveStandardQuestions = function(onSuccess, onFailure) {
        try {
            var url = "/v3/lps/api/ProfileSiteQuestions";
            var ajaxData = {
            };

            var startTime = new Date().getTime();
            var timeoutValue = 30000;
            jQuery.ajax({
                headers: PeopleMedia.CP.LpsPostbackHeader(),
                type: "POST",
                url: url,
                data: JSON.stringify(ajaxData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(profileSiteQuestionsResponse) {
                    retrieveStandardQuestionsComplete(onSuccess,
                        onFailure,
                        null,
                        profileSiteQuestionsResponse);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "retrieveStandardQuestions", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    retrieveStandardQuestionsComplete(onSuccess, onFailure, data, null);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "retrieveStandardQuestions" });
        }
    };

    var retrieveStandardQuestionsComplete = function (onSuccess, onFailure, err, profileSiteQuestionsResponse) {
        try {
            PeopleMedia.CP.ui_done();
            var errorArray = [];
            if (err === null && profileSiteQuestionsResponse && profileSiteQuestionsResponse.ProfileQuestions && Array.isArray(profileSiteQuestionsResponse.ProfileQuestions)) {
                _standardQuestions = [];
                _profileSiteQuestions = profileSiteQuestionsResponse.ProfileQuestions;
                var legacyStandardQuestions = convertProfileQuestionsIntoLegacyProfileQuestions(profileSiteQuestionsResponse.ProfileQuestions);
                for (var i = 0; i < legacyStandardQuestions.length; i++) {
                    if (legacyStandardQuestions[i].IsSignupQuestion) {
                        _standardQuestions.push(legacyStandardQuestions[i]);
                    }
                }
                addInsertedQuestionsToStandardQuestions(legacyStandardQuestions);
                if (typeof (onSuccess) === "function") {
                    onSuccess(_standardQuestions);
                }
                return;
            }
            if (err && err.Fault) {
                if (!err.Fault.IsCancelled) {
                    errorArray.push(PeopleMedia.CP.convertFaultToError(err.Fault));
                }
            } else {
                errorArray.push(PeopleMedia.CP.createGeneralError());
            }
            if (typeof (onFailure) === "function") {
                onFailure(errorArray, err);
            }
        }
        catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "retrieveStandardQuestionsComplete" });
        }
    };

    var isSignupQuestion = function(siteId, questionId) {
        var isSignup = [1, 2, 4, 5, 10, 16, 17, 18, 19, 96, 98, 101, 104, 105, 108];
        if (isSignup.indexOf(questionId) >= 0) {
            return true;
        }
        if (questionId === 88) {
            return (siteId === 27);
        }
        if (questionId === 124) {
            return (siteId === 117);
        }
        return false;
    };

    var legacyProfileQuestionSequence = function(siteId) {
        // for backward compatibility with GetQuestionsAndResponses
        switch (siteId) {
        case 21:
        case 22:
        case 26:
        case 30:
            return [1, 2, 19, 101, 4, 5, 16, 17, 99, 7, 88, 9, 257, 256, 98, 124];
        case 24:
            return [1, 2, 19, 5, 16, 17, 103, 9, 99, 98, 4, 257, 256, 124, 104, 7, 105];
        case 25:
            return [1, 2, 19, 101, 4, 5, 16, 17, 99, 10, 7, 108, 9, 257, 256, 124, 98];
        case 27:
            return [1, 2, 19, 101, 4, 5, 16, 17, 99, 7, 88, 9, 257, 256, 124, 98];
        case 28:
            return [1, 2, 19, 101, 4, 5, 16, 17, 7, 10, 9, 97, 257, 256, 124, 96];
        case 29:
        case 31:
        case 32:
            return [1, 2, 19, 101, 4, 5, 16, 17, 88, 99, 9, 98, 257, 7, 256, 124];
        case 165:
            return [1, 2, 18, 101, 4, 5, 16, 17, 88, 99, 9, 256, 98, 257, 7, 124];
        case 122:
        case 162:
            return [1, 2, 19, 101, 4, 5, 16, 17, 99, 9, 256, 98, 7, 257, 124];
        default:
            return [1, 2, 19, 101, 4, 5, 16, 17, 88, 99, 9, 256, 98, 257, 7, 124];
        }
    };

    var convertProfileQuestionsIntoLegacyProfileQuestions = function(profileSiteQuestions) {
        var legacyProfileQuestions = [];
        try {
            var currentSiteId = SiteId();
            var legacySequence = legacyProfileQuestionSequence(currentSiteId);
            for (var i = 0; i < legacySequence.length; i++) {
                var questionId = legacySequence[i];
                var profileQuestion = null;
                for (var q = 0; q < profileSiteQuestions.length; q++) {
                    if (profileSiteQuestions[q] !== null && profileSiteQuestions[q].Id === questionId) {
                        profileQuestion = profileSiteQuestions[q];
                        break;
                    }
                }
                if (profileQuestion !== null) {
                    var legacyQuestion = {
                        "IsSignupQuestion": isSignupQuestion(currentSiteId, profileQuestion.Id),
                        "QuestionID": profileQuestion.Id,
                        "QuestionText": (profileQuestion.Text || "").replace("Pet(s)", "Pet"),
                        "Required": false,
                        "Responses": []
                    };
                    if (profileQuestion.Responses && Array.isArray(profileQuestion.Responses)) {
                        legacyQuestion.Responses = $jq.map(profileQuestion.Responses,
                            function(resp) {
                                return {
                                    "ResponseID": resp.Id,
                                    "ResponseText": resp.Text
                                };
                            });
                    }
                    legacyProfileQuestions.push(legacyQuestion);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "convertProfileQuestionsIntoLegacyProfileQuestions" });
        }
        return legacyProfileQuestions;
    };

    var addInsertedQuestionsToStandardQuestions = function(data) {
        try {
            var newStandardQuestions;
            var newStandardQuestionsMerged;
            var includedQuestions = IncludedQuestions();
            var isFound;
            var insertPosition;
            var insertType;
            var findId;
            var i;
            var j;

            if (typeof (data) === 'undefined' || data === null || !Array.isArray(data) || data.length === 0) {
                return;
            }
            if (typeof (includedQuestions) === 'undefined' ||
                includedQuestions === null ||
                Array.isArray(includedQuestions) === false ||
                includedQuestions.length === 0) {
                return;
            }

            // assign data values for inserted questions
            for (i = 0; i < data.length; i++) {
                for (j = 0; j < includedQuestions.length; j++) {
                    if (data[i].QuestionID === includedQuestions[j].QuestionID) {
                        includedQuestions[j].data = data[i];
                        includedQuestions[j].data.IsSignupQuestion = true;
                        break;
                    }
                }
            }
            IncludedQuestions(includedQuestions);

            // remove any inserted questions from newStandardQuestions to prevent duplicates
            // create a copy of _standardQuestions in case there is an exception
            newStandardQuestions = [];
            for (i = 0; i < _standardQuestions.length; i++) {
                isFound = false;
                for (j = 0; j < includedQuestions.length; j++) {
                    if (_standardQuestions[i].QuestionID === includedQuestions[j].QuestionID) {
                        isFound = true;
                        break;
                    }
                }
                if (!isFound) {
                    newStandardQuestions.push(_standardQuestions[i]);
                }
            }

            // merge arrays
            for (i = 0; i < includedQuestions.length; i++) {
                if (includedQuestions[i] && includedQuestions[i].data) {
                    if (typeof (includedQuestions[i].Position) !== 'undefined' && includedQuestions[i].Position >= 0) {
                        insertType = "before";
                        insertPosition = includedQuestions[i].Position;
                        findId = -1;
                    } else if (typeof (includedQuestions[i].InsertBeforeQuestionID) !== 'undefined' &&
                        includedQuestions[i].InsertBeforeQuestionID > 0) {
                        insertType = "before";
                        insertPosition = -1;
                        findId = includedQuestions[i].InsertBeforeQuestionID;
                    } else if (typeof (includedQuestions[i].InsertAfterQuestionID) !== 'undefined' &&
                        includedQuestions[i].InsertAfterQuestionID > 0) {
                        insertType = "after";
                        insertPosition = -1;
                        findId = includedQuestions[i].InsertAfterQuestionID;
                    } else {
                        insertType = "after";
                        insertPosition = -1;
                        findId = -1;
                    }

                    // do we need to search for an insert position?
                    if (findId > 0) {
                        // special case for question id 999 since it is not in the standard list but appears at the beginning
                        if (findId === 999) {
                            insertType = "before";
                            insertPosition = 0;
                        } else {
                            for (j = 0; j < newStandardQuestions.length; j++) {
                                if (newStandardQuestions[j].QuestionID === findId) {
                                    insertPosition = j;
                                    break;
                                }
                            }
                        }
                    }

                    // if insertType is before but the item is not found then add it to the beginning
                    if (insertPosition < 0 && insertType === "before") {
                        insertPosition = 0;
                    }

                    // we have a position, now add it to the correct place
                    if (insertPosition >= 0 && insertPosition < newStandardQuestions.length) {
                        newStandardQuestionsMerged = [];
                        for (j = 0; j < newStandardQuestions.length; j++) {
                            if (insertType === "before" && j === insertPosition) {
                                newStandardQuestionsMerged.push(includedQuestions[i].data);
                            }
                            newStandardQuestionsMerged.push(newStandardQuestions[j]);
                            if (insertType !== "before" && j === insertPosition) {
                                newStandardQuestionsMerged.push(includedQuestions[i].data);
                            }
                        }
                        newStandardQuestions = newStandardQuestionsMerged;
                    } else {
                        // append to the end
                        newStandardQuestions.push(includedQuestions[i].data);
                    }
                }
            }

            _standardQuestions = newStandardQuestions;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "addInsertedQuestionsToStandardQuestions" });
        }
    };

    var getQuestionResponsesFromForm = function() {
        var questionResponseIds = [];
        try {
            var fieldPrefix = "#" + ResponseFieldnamePrefix();
            var responsePrefix = "#ddlProfileResponse_";

            for (var i = 0; i < StandardQuestions().length; i++) {
                var questionIdStr = StandardQuestions()[i].QuestionID;
                var questionId = parseInt(questionIdStr, 10);
                var $question = $jq(fieldPrefix + questionIdStr);
                if ($question.length > 0) {
                    var $response = $jq(responsePrefix + questionIdStr);
                    if ($response.length > 0) {
                        var val = $response.val();
                        var responseId = parseInt(val, 10);
                        if (!isNaN(questionId) && !isNaN(responseId)) {
                            questionResponseIds.push({
                                "QuestionId": questionId,
                                "ResponseId": responseId
                            });
                        }
                    }
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getQuestionResponsesFromForm" });
        }
        return questionResponseIds;
    };

    var submit = function() {
        try {
            if (typeof(_onQuestionsPreSubmit) !== 'undefined' && _onQuestionsPreSubmit !== null) {
                var cont = _onQuestionsPreSubmit(this, Questions());
                if (!cont) {
                    return;
                }
            }
            if (typeof (Questions()) === 'undefined' || Questions() === null) {
                return;
            }

            var questionResponses = getQuestionResponsesFromForm();

            enterBusyMode();

            authenticate(function(authenticateErr, authenticateResponse) {
                if (authenticateErr === null && authenticateResponse && authenticateResponse.requestData) {
                    var apiContext = authenticateResponse.requestData.Context || {};
                    var apiAuthToken = authenticateResponse.requestData.Token || {};
                    updateProfileQuestions(apiContext,
                        apiAuthToken,
                        questionResponses,
                        function(updateProfileQuestionsError, updateProfileQuestionsResponse) {
                            exitBusyMode();
                            if (updateProfileQuestionsError === null || updateProfileQuestionsError.IsAjaxError) {
                                questionsCompleted();
                            } else {
                                var errors = [];
                                errors.push(updateProfileQuestionsError);
                                PeopleMedia.CP.Messaging.show(errors);
                            }
                        });
                }
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "submit" });
        }
    };

    var updateProfileQuestions = function(apiContext, apiAuthToken, questionResponses, onComplete) {
        try {
            var url = "/v3/lps/api/UpdateProfileComplete";
            var ajaxData = {
                "ProfileQuestions": questionResponses
            };

            var startTime = new Date().getTime();
            var timeoutValue = 60000;
            jQuery.ajax({
                headers: PeopleMedia.CP.LpsPostbackHeader(),
                type: "POST",
                url: url,
                data: JSON.stringify(ajaxData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(updateProfileQuestionsResponse) {
                    var detailResponse = $jq.extend({},
                        updateProfileQuestionsResponse,
                        {
                            Context: apiContext,
                            Token: apiAuthToken
                        });
                    onComplete(null, detailResponse);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "updateProfileQuestions", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    onComplete(data, null);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "updateProfileQuestions" });
        }
    };

    var authenticate = function(onComplete) {
        try {
            PeopleMedia.CP.ui_busy();

            var selfProfileCompleteRequest = {};
            PeopleMedia.CP.getSelfProfileComplete(selfProfileCompleteRequest,
                function(profileErr, getSelfProfileCompleteResponse) {

                    PeopleMedia.CP.ui_done();

                    if (profileErr === null && getSelfProfileCompleteResponse) {
                        if (typeof (onComplete) === "function") {
                            onComplete(null, getSelfProfileCompleteResponse);
                        }
                    } else {
                        // can't retrieve profile
                        if (typeof (onComplete) === "function") {
                            onComplete(PeopleMedia.CP.createGeneralError(profileErr), null);
                        }
                    }
                });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "authenticate" });
        }
    };

    var reset = function() {
        try {
            _questions = [];
            _standardQuestions = [];
            if (typeof(_initialQuestions) === 'undefined' || _initialQuestions === null) {
                _initialQuestions = [];
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "reset" });
        }
    };

    var questionsCompleted = function() {
        try {
            if (typeof(_onQuestionsSubmitted) !== 'undefined' && _onQuestionsSubmitted !== null) {
                _onQuestionsSubmitted();
            } else if (typeof (NextPage()) !== 'undefined' && NextPage() !== null && NextPage().length > 0) {
                PeopleMedia.CP.gotoCPPage(NextPage());
            } else {
                PeopleMedia.CP.gotoCPPage("/site/landingpages/shared/essay-02.html");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "questionsCompleted" });
            PeopleMedia.CP.gotoCPPage("/site/landingpages/shared/essay-02.html");
        }
    };

    var addQuestionHTMLToPanel = function(question, index) {
        try {
            if ($jq('#' + QuestionContainerId()).length > 0 && $jq('#' + QuestionTemplateId()).length > 0) {
                var html = getQuestionHTML(question, index);
                $jq('#' + QuestionContainerId()).append(html);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "addQuestionHTMLToPanel" });
        }
    };

    var getQuestionHTML = function(question, index) {
        try {
            var questionText = question.QuestionText;
            if (typeof(_questionTextOverride[question.QuestionID]) !== 'undefined' &&
                _questionTextOverride[question.QuestionID] !== null) {
                questionText = _questionTextOverride[question.QuestionID];
            }

            var html = $jq("#" + QuestionTemplateId()).html();
            html = html.replace(/\$QUESTION_NUMBER\$/g, index + 1);
            html = html.replace(/\$QUESTION_ID\$/g, question.QuestionID);
            html = html.replace(/\$QUESTION\$/g, questionText);
            html = html.replace(/\$RESPONSES\$/g, getResponseHTML(question));
            return html;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getQuestionHTML" });
            return "";
        }
    };

    var getResponseHTML = function(question) {
        if (_defaultOptionListType === OPTION_LIST_TYPE_DIV) {
            return getResponseHTML_Div(question);
        } else {
            return getResponseHTML_DDL_List(question);
        }
    };

    var isResponseExcludedForGender = function(gender, question, responseIndex) {
        var isExcluded = false;
        // General Build question (QuestionID 4)
        if (question.QuestionID === 4) {
            var responseID = question.Responses[responseIndex].ResponseID;
            // Males have Big & Beautiful (ResponseID 5) excluded
            // Females have Heavyset (ResponseID 6) and Stocky (ResponseID 7) excluded
            if (gender === 1 && responseID === 5) {
                isExcluded = true;
            } else if (gender === 2 && (responseID === 6 || responseID === 7)) {
                isExcluded = true;
            }
        }
        return isExcluded;
    };

    var getResponseHTML_DDL_List = function(question) {
        try {
            // determine size of list, if needed
            var sizeAttr = "";
            var isExcluded = false;
            var i;
            var gender = PeopleMedia.CP.GenderID();
            if (_defaultOptionListType === OPTION_LIST_TYPE_LIST) {
                var size = 0;
                for (i = 0; i < question.Responses.length; ++i) {
                    isExcluded = false;
                    if (typeof(_responseExclusions[question.QuestionID]) !== 'undefined' &&
                        _responseExclusions[question.QuestionID] !== null) {
                        if (_responseExclusions[question.QuestionID][question.Responses[i].ResponseID] === true) {
                            isExcluded = true;
                        }
                    }
                    if (isResponseExcludedForGender(gender, question, i)) {
                        isExcluded = true;
                    }
                    if (!isExcluded) {
                        ++size;
                    }
                }

                if (size > _maxListViewSize) {
                    size = _maxListViewSize;
                }

                sizeAttr = "size='" + size.toString() + "'";
            }

            // add auto-submit on click
            var onClickAttr = "";
            if (_defaultOptionListType === OPTION_LIST_TYPE_LIST) {
                onClickAttr = "onclick='javascript:PeopleMedia.CP.Profile.showNextPanel();return false;'";
            }

            var ddlHtml = "<select id='" + 
                ResponseFieldnamePrefix() +
                question.QuestionID.toString() +
                "' name='" +
                ResponseFieldnamePrefix() +
                question.QuestionID.toString() +
                "' " +
                sizeAttr +
                " " +
                onClickAttr +
                " data-questionid='" + question.QuestionID.toString() + "' " + 
                ">";

            if (_addChooseOptionToResponses && _defaultOptionListType !== OPTION_LIST_TYPE_LIST) {
                ddlHtml += "<option value=''>Choose</option>";
            }

            for (i = 0; i < question.Responses.length; ++i) {
                var responseText = question.Responses[i].ResponseText;
                if (typeof(_responseTextOverride[question.QuestionID]) !== 'undefined' && _responseTextOverride[question.QuestionID] !== null) {
                    if (typeof(_responseTextOverride[question.QuestionID][question.Responses[i].ResponseID]) !== 'undefined' &&
                        _responseTextOverride[question.QuestionID][question.Responses[i].ResponseID] !== null) {
                        responseText = _responseTextOverride[question.QuestionID][question.Responses[i].ResponseID];
                    }
                }
                isExcluded = false;
                if (typeof(_responseExclusions[question.QuestionID]) !== 'undefined' && _responseExclusions[question.QuestionID] !== null) {
                    if (_responseExclusions[question.QuestionID][question.Responses[i].ResponseID] === true) {
                        isExcluded = true;
                    }
                }
                if (isResponseExcludedForGender(gender, question, i)) {
                    isExcluded = true;
                }
                if (!isExcluded) {
                    if (typeof question.DefaultValue !== 'undefined' && question.DefaultValue !== null &&
                        question.DefaultValue === question.Responses[i].ResponseID) {
                        ddlHtml += "<option value='" +
                            question.Responses[i].ResponseID +
                            "' selected='selected'>" +
                            responseText +
                            "</option>";
                    } else {
                        ddlHtml += "<option value='" +
                            question.Responses[i].ResponseID +
                            "'>" +
                            responseText +
                            "</option>";
                    }
                }
            }
            ddlHtml += "</select>";
            return ddlHtml;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getResponseHTML_DDL_List" });
            return "";
        }
    };

    var getResponseHTML_Div = function(question) {
        try {
            var gender = PeopleMedia.CP.GenderID();
            var onClickAttr = "onclick='javascript:";
            onClickAttr += "$jq(\"#" +
                ResponseFieldnamePrefix() +
                question.QuestionID.toString() +
                "\").val(\"##RESPONSEID##\");";
            onClickAttr += "PeopleMedia.CP.Profile.showNextPanel();";
            onClickAttr += "return false;'";

            var html;
            if (typeof question.DefaultValue !== 'undefined' && question.DefaultValue !== null) {
                html = "<input type='hidden' id='" +
                    ResponseFieldnamePrefix() +
                    question.QuestionID.toString() +
                    "' name='" +
                    ResponseFieldnamePrefix() +
                    question.QuestionID.toString() +
                    "' value='" +
                    question.DefaultValue.toString() +
                    "' data-questionid='" + question.QuestionID.toString() + "' " + 
                    "/>";
            } else {
                html = "<input type='hidden' id='" +
                    ResponseFieldnamePrefix() +
                    question.QuestionID.toString() +
                    "' name='" +
                    ResponseFieldnamePrefix() +
                    question.QuestionID.toString() +
                    "' data-questionid='" + question.QuestionID.toString() + "' " + 
                    "/>";
            }

            html += "<div class='profileresponsecontainer' data-questionid='" + question.QuestionID.toString() + "'>";

            for (var i = 0; i < question.Responses.length; ++i) {
                var responseText = question.Responses[i].ResponseText;
                if (typeof(_responseTextOverride[question.QuestionID]) !== 'undefined' && _responseTextOverride[question.QuestionID] !== null) {
                    if (typeof(_responseTextOverride[question.QuestionID][question.Responses[i].ResponseID]) !== 'undefined' &&
                        _responseTextOverride[question.QuestionID][question.Responses[i].ResponseID] !== null) {
                        responseText = _responseTextOverride[question.QuestionID][question.Responses[i].ResponseID];
                    }
                }
                var isExcluded = false;
                if (typeof(_responseExclusions[question.QuestionID]) !== 'undefined' && _responseExclusions[question.QuestionID] !== null) {
                    if (_responseExclusions[question.QuestionID][question.Responses[i].ResponseID] === true) {
                        isExcluded = true;
                    }
                }
                if (isResponseExcludedForGender(gender, question, i)) {
                    isExcluded = true;
                }
                if (!isExcluded) {
                    html += "<div id='profileresponse_" +
                        question.QuestionID +
                        "_" +
                        question.Responses[i].ResponseID +
                        "' class='profileresponse' " +
                        onClickAttr.replace('##RESPONSEID##', question.Responses[i].ResponseID) +
                        ">" +
                        responseText +
                        "</div>";
                }
            }

            html += "</div>";
            return html;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getResponseHTML_Div" });
            return "";
        }
    };

    var getCurrentQuestion = function() {
        try {
            if (_currentPanelNumber < 1 || _currentPanelNumber > Questions().length) {
                return null;
            }
            return Questions()[_currentPanelNumber - 1];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestion" });
        }
        return null;
    };

    var getCurrentQuestionID = function() {
        try {
            var question = getCurrentQuestion();
            if (typeof question !== 'undefined' && question !== null && typeof question.QuestionID !== 'undefined') {
                return question.QuestionID;
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestionID" });
        }
        return null;
    };

    var getCurrentQuestionValue = function() {
        try {
            var question = getCurrentQuestion();
            if (typeof question !== 'undefined' && question !== null && typeof question.QuestionID !== 'undefined') {
                return $jq("#" + ResponseFieldnamePrefix() + question.QuestionID).val() || null;
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestionValue" });
        }
        return null;
    };

    var updateQuestionPlaceholder = function(question) {
        try {
            if ($jq('#question_' + question.QuestionID).length > 0) {
                $jq('#question_' + question.QuestionID).append(question.QuestionText);
            }
            if ($jq('#response_' + question.QuestionID).length > 0) {
                $jq('#response_' + question.QuestionID).html(getResponseHTML(question));
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "updateQuestionPlaceholder" });
        }
    };

    var fireOnQuestionDisplay = function() {
        try {
            if (typeof(_onQuestionDisplay) !== 'undefined' && _onQuestionDisplay !== null) {
                _onQuestionDisplay();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "fireOnQuestionDisplay" });
        }
    };

    var showHideDependentQuestion = function(dependeeQID, dependantQID, exceptionDependeeAnswer, defaultDependantAnswer) {
        try {
            var v = $jq("#response_" + dependeeQID + " > :input").val();
            if (typeof(v) !== 'undefined' && v !== null && v.length > 0 && v !== exceptionDependeeAnswer) {
                $jq("#divQuestion_" + dependantQID).show();
                $jq("#response_" + dependantQID + " > :input").val("");
            } else {
                $jq("#divQuestion_" + dependantQID).hide();
                $jq("#response_" + dependantQID + " > :input").val(defaultDependantAnswer);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showHideDependentQuestion" });
        }
    };

    var showNextPanel = function() {
        try {
            var question = Questions()[_currentPanelNumber - 1];
            var val = $jq("#" + ResponseFieldnamePrefix() + question.QuestionID).val();
            if (typeof(val) === 'undefined' || val === null || val.length === 0) {
                PeopleMedia.CP.Messaging.show([
                    { Text: "Please choose your " + question.QuestionText.replace("_", "") + "." }
                ]);
            } else {
                PeopleMedia.CP.Messaging.reset();
                if (_currentPanelNumber < _panelCount) {
                    ++_currentPanelNumber;
                    // handle #children/#livingathome dependency
                    if (question.QuestionID === 16 && (val === 0 || val === "0")) {
                        $jq("#" + ResponseFieldnamePrefix() + "17").val("0");
                        ++_currentPanelNumber;
                    }
                    showPanel(_currentPanelNumber, "showNextPanel");
                } else if (_currentPanelNumber === _panelCount) {
                    submit();
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showNextPanel" });
        }
    };

    var showPreviousPanel = function() {
        try {
            if (_currentPanelNumber > 1) {
                // handle #children/#livingathome dependency
                if (_currentPanelNumber > 2) {
                    var question = Questions()[_currentPanelNumber - 3];
                    if (question.QuestionID === 16) {
                        var val = $jq("#" + ResponseFieldnamePrefix() + question.QuestionID).val();
                        if (typeof(val) !== 'undefined' && val !== null && val.length !== 0) {
                            if (val === 0 || val === "0") {
                                --_currentPanelNumber;
                            }
                        }
                    }
                }
                PeopleMedia.CP.Messaging.reset();
                --_currentPanelNumber;
                showPanel(_currentPanelNumber, "showPreviousPanel");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showPreviousPanel" });
        }
    };

    var validatePanel = function() {
        try {
            var errors = [];
            $jq("#divProfileQuestions_" +
                _currentPanelNumber.toString() +
                " select[id^=\"" +
                ResponseFieldnamePrefix() +
                "\"]").each(function() {
                var questionID = $jq(this).attr('id').substr(ResponseFieldnamePrefix().length);
                var question = getQuestionByID(questionID);
                if (typeof (question) !== 'undefined' && question !== null) {
                    var val = $jq("#" + ResponseFieldnamePrefix() + question.QuestionID).val();
                    if (typeof(val) === 'undefined' || val === null || val.length === 0) {
                        errors.push({
                            Text: "Please choose your " + question.QuestionText.replace("_", "") + ".",
                            Field: ResponseFieldnamePrefix() + question.QuestionID
                        });
                    }
                }
            });
            return errors;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePanel" });
            return [];
        }
    };

    var validateAndShowPanel = function(panelNum) {
        try {
            var errors = validatePanel(panelNum);
            if (errors.length > 0) {
                PeopleMedia.CP.Messaging.show(errors);
            } else {
                showPanel(panelNum, "validateAndShowPanel");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateAndShowPanel" });
        }
    };

    var validateAndSubmit = function(panelNum) {
        try {
            var errors = validatePanel(panelNum);
            if (errors.length > 0) {
                PeopleMedia.CP.Messaging.show(errors);
            } else {
                submit();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateAndSubmit" });
        }
    };

    var showPanel = function(panelNum, source) {
        try {
            PeopleMedia.CP.Messaging.reset();

            if ((_questions === null || _questions.length === 0) && PeopleMedia.CP.Member && PeopleMedia.CP.Member.PublicMemberId) {
                submit();
            }
            var $currentPanel = $jq('#divProfileQuestions_' + panelNum.toString());
            if ($currentPanel.length > 0) {
                for (var i = 1; i <= _panelCount; ++i) {
                    if ($jq('#divProfileQuestions_' + i.toString()).length > 0) {
                        $jq('#divProfileQuestions_' + i.toString()).hide();
                    }
                }
                var gender;
                var question = Questions()[panelNum - 1];
                if (question && question.QuestionID === 4) {
                    if (PeopleMedia.CP.GenderSeekEnabled() === true) {
                        gender = ($jq('#ddlProfileResponse_999').val() !== null ? Math.floor($jq('#ddlProfileResponse_999').val() / 10) : null) || $jq.queryString.get("iam") || PeopleMedia.CP.GenderID();
                    } else {
                        gender = $jq('#ddlProfileResponse_13').val() || $jq.queryString.get("iam") || PeopleMedia.CP.GenderID();
                    }
                    var $ddlProfileResponse = $jq('#ddlProfileResponse_4');
                    if (gender === 1) {
                        $jq('#profileresponse_4_5').removeClass('profileresponse_selected').hide();
                        $jq('#profileresponse_4_6,#profileresponse_4_7').show();
                        if ($ddlProfileResponse.length > 0) {
                            $ddlProfileResponse.children()
                                .filter('option[value="5"]').removeClass('profileresponse_selected').hide().end()
                                .filter('option[value="6"],option[value="7"]').show();
                            if ($ddlProfileResponse.val() === "5") {
                                $ddlProfileResponse.val("");
                            }
                        }
                    } else if (gender === 2) {
                        $jq('#profileresponse_4_5').show();
                        $jq('#profileresponse_4_6,#profileresponse_4_7').removeClass('profileresponse_selected').hide();
                        if ($ddlProfileResponse.length > 0) {
                            if ($ddlProfileResponse.length > 0) {
                                $ddlProfileResponse.children()
                                    .filter('option[value="5"]').show().end()
                                    .filter('option[value="6"],option[value="7"]')
                                    .removeClass('profileresponse_selected').hide();
                                if ($ddlProfileResponse.val() === "6" || $ddlProfileResponse.val() === "7") {
                                    $ddlProfileResponse.val("");
                                }
                            }
                        }
                    }
                }

                $currentPanel.show();
                _currentPanelNumber = panelNum;

                var questionContainerId = '#divProfileQuestions_' + panelNum.toString();
                PeopleMedia.CP.trackRegistrationEventShow(questionContainerId, source);

                var displayedQuestions = getDisplayedQuestionIds($currentPanel);
                if (displayedQuestions.length > 0) {
                    PeopleMedia.CP.trackRegistrationEventShowRegQuestions(displayedQuestions);
                }
                fireOnQuestionDisplay();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showPanel" });
        }
    };

    var getQuestionByID = function(questionID) {
        try {
            for (var i = 0; i < _questions.length; ++i) {
                if (_questions[i].QuestionID === questionID) {
                    return _questions[i];
                }
            }
            return null;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getQuestionByID" });
            return null;
        }
    };

    var getResponseByQuestionID = function(questionID) {
        try {
            var question = getQuestionByID(questionID);
            if (typeof (question) !== 'undefined' && question !== null) {
                var val = $jq("#" + ResponseFieldnamePrefix() + question.QuestionID).val();
                if (typeof (val) !== 'undefined') {
                    return val;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getResponseByQuestionID" });
            return null;
        }
    };

    var getResponseSeekingGender = function() {
        try {
            genderResponse = getResponseByQuestionID(999);
            if (genderResponse !== null && genderResponse.length === 2) {
                return genderResponse.substr(1, 1);
            }
            var genderResponse = getResponseByQuestionID(13);
            if (genderResponse !== null && genderResponse !== '') {
                return (genderResponse === '2') ? '1' : '2';
            }
            return null;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getResponseSeekingGender" });
            return null;
        }
    };

    var enterBusyMode = function() {
        try {
            $jq("." + BusyClassname()).each(function() {
                $jq(this).fadeTo('fast', '0.3');
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "enterBusyMode" });
        }
    };

    var exitBusyMode = function() {
        try {
            $jq("." + BusyClassname()).each(function() {
                $jq(this).fadeTo('fast', '1.0');
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "exitBusyMode" });
        }
    };

    var getDisplayedQuestionIds = function ($container) {
        var result = [];
        try {
            if (typeof ($container) === 'undefined' || $container === null || $container.length === 0) {
                return result;
            }
            $container.find("[data-questionid]").each(function () {
                var id = $jq(this).attr("data-questionid");
                if (!PeopleMedia.CP.Utilities.isNullOrEmpty(id)) {
                    var idNum = parseInt(id, 10);
                    // only return unique values
                    if (!isNaN(idNum) && result.indexOf(idNum) === -1) {
                        result.push(idNum);
                    }
                }
            });
            return result;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getDisplayedQuestionIds" });
            return result;
        }
    };

    return {
        IncludedQuestions: IncludedQuestions,
        ExcludedQuestions: ExcludedQuestions,
        QuestionDefaultValues: QuestionDefaultValues,
        Questions: Questions,
        InitialQuestions: InitialQuestions,
        ProfilePanelId: ProfilePanelId,
        ProfilePanel: ProfilePanel,
        QuestionContainerId: QuestionContainerId,
        ResponseFieldnamePrefix: ResponseFieldnamePrefix,
        OnQuestionsLoaded: OnQuestionsLoaded,
        OnQuestionDisplay: OnQuestionDisplay,
        OnQuestionsPreSubmit: OnQuestionsPreSubmit,
        OnQuestionsSubmitted: OnQuestionsSubmitted,
        CurrentPanelNumber: CurrentPanelNumber,
        PanelCount: PanelCount,
        DefaultOptionListType: DefaultOptionListType,
        AddChooseOptionToResponses: AddChooseOptionToResponses,
        NextPage: NextPage,
        addQuestionTextOverride: addQuestionTextOverride,
        addResponseTextOverride: addResponseTextOverride,
        excludeResponse: excludeResponse,
        loadQuestions: loadQuestions,
        submit: submit,
        getCurrentQuestion: getCurrentQuestion,
        getCurrentQuestionID: getCurrentQuestionID,
        getCurrentQuestionValue: getCurrentQuestionValue,
        // fireOnQuestionDisplay: fireOnQuestionDisplay,
        showHideDependentQuestion: showHideDependentQuestion,
        showNextPanel: showNextPanel,
        showPreviousPanel: showPreviousPanel,
        validateAndShowPanel: validateAndShowPanel,
        validateAndSubmit: validateAndSubmit,
        showPanel: showPanel,
        getResponseByQuestionID: getResponseByQuestionID,
        getResponseSeekingGender: getResponseSeekingGender,
        getDisplayedQuestionIds: getDisplayedQuestionIds
    };

})(jQuery);

// for backwards compatibility only
PeopleMedia.CP.ProfileManager = function () {
};

// for backwards compatibility only
PeopleMedia.CP.ProfileManager.prototype = {
    IncludedQuestions: PeopleMedia.CP.Profile.IncludedQuestions,
    ExcludedQuestions: PeopleMedia.CP.Profile.ExcludedQuestions,
    QuestionDefaultValues: PeopleMedia.CP.Profile.QuestionDefaultValues,
    Questions: PeopleMedia.CP.Profile.Questions,
    InitialQuestions: PeopleMedia.CP.Profile.InitialQuestions,
    ProfilePanelId: PeopleMedia.CP.Profile.ProfilePanelId,
    ProfilePanel: PeopleMedia.CP.Profile.ProfilePanel,
    QuestionContainerId: PeopleMedia.CP.Profile.QuestionContainerId,
    ResponseFieldnamePrefix: PeopleMedia.CP.Profile.ResponseFieldnamePrefix,
    OnQuestionsLoaded: PeopleMedia.CP.Profile.OnQuestionsLoaded,
    OnQuestionDisplay: PeopleMedia.CP.Profile.OnQuestionDisplay,
    OnQuestionsPreSubmit: PeopleMedia.CP.Profile.OnQuestionsPreSubmit,
    OnQuestionsSubmitted: PeopleMedia.CP.Profile.OnQuestionsSubmitted,
    CurrentPanelNumber: PeopleMedia.CP.Profile.CurrentPanelNumber,
    PanelCount: PeopleMedia.CP.Profile.PanelCount,
    DefaultOptionListType: PeopleMedia.CP.Profile.DefaultOptionListType,
    AddChooseOptionToResponses: PeopleMedia.CP.Profile.AddChooseOptionToResponses,
    NextPage: PeopleMedia.CP.Profile.NextPage,
    addQuestionTextOverride: PeopleMedia.CP.Profile.addQuestionTextOverride,
    addResponseTextOverride: PeopleMedia.CP.Profile.addResponseTextOverride,
    excludeResponse: PeopleMedia.CP.Profile.excludeResponse,
    loadQuestions: PeopleMedia.CP.Profile.loadQuestions,
    submit: PeopleMedia.CP.Profile.submit,
    getCurrentQuestion: PeopleMedia.CP.Profile.getCurrentQuestion,
    getCurrentQuestionID: PeopleMedia.CP.Profile.getCurrentQuestionID,
    getCurrentQuestionValue: PeopleMedia.CP.Profile.getCurrentQuestionValue,
    //fireOnQuestionDisplay: PeopleMedia.CP.Profile.fireOnQuestionDisplay,
    showHideDependentQuestion: PeopleMedia.CP.Profile.showHideDependentQuestion,
    showNextPanel: PeopleMedia.CP.Profile.showNextPanel,
    showPreviousPanel: PeopleMedia.CP.Profile.showPreviousPanel,
    validateAndShowPanel: PeopleMedia.CP.Profile.validateAndShowPanel,
    validateAndSubmit: PeopleMedia.CP.Profile.validateAndSubmit,
    showPanel: PeopleMedia.CP.Profile.showPanel,
    getResponseByQuestionID: PeopleMedia.CP.Profile.getResponseByQuestionID,
    getResponseSeekingGender: PeopleMedia.CP.Profile.getResponseSeekingGender
};
